import React, { Component } from 'react';
import { bool, func } from 'prop-types';
import { connect } from 'react-redux';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';
import { get } from '../../../container';
import { isAuthenticated as isAuthenticatedAction } from '../../auth/actions/auth';
import { getAllServices as getAllServicesAction } from '../../services/actions/services';
import { getProfile as getProfileAction } from '../../profile/actions/profile';

// Components
import NotFound from '../components/NotFound';
import PrivateRoute from '../components/routes/PrivateRoute';
import AuthRoute from '../components/routes/AuthRoute';
import SearchService from '../../services/containers/SearchService';
import Signin from '../../auth/containers/Signin';
import Profile from '../../profile/containers/Profile';

// Routes
import {
  ROUTE_HOME,
  ROUTE_LOGIN,
  ROUTE_PROFILE,
} from '../../../routes';

class App extends Component {
  static propTypes = {
    isAuthenticated: func.isRequired,
    getAllServices: func.isRequired,
    getProfile: func.isRequired,
    authenticated: bool.isRequired,
  };

  /**
   * {@inheritdoc}
   */
  componentDidMount() {
    this.props.isAuthenticated();
  }

  /**
   * {@inheritdoc}
   */
  componentDidUpdate(prevProps) {
    const { authenticated, getAllServices, getProfile } = this.props;

    if (prevProps.authenticated !== authenticated && authenticated) {
      getAllServices();
      getProfile();
    }
  }

  /**
   * {@inheritdoc}
   */
  render() {
    return (
      <Router basename={get('base_name')}>
        <Switch>
          <PrivateRoute exact path={ROUTE_HOME} component={SearchService} />
          <PrivateRoute exact path={ROUTE_PROFILE} component={Profile} />
          <AuthRoute exact path={ROUTE_LOGIN} component={Signin} />
          <Route component={NotFound} />
        </Switch>
      </Router>
    );
  }
}

const mapStateToProps = state => ({
  authenticated: state.auth.authenticated,
});

const mapDispatchToProps = dispatch => ({
  isAuthenticated: () => dispatch(isAuthenticatedAction()),
  getAllServices: () => dispatch(getAllServicesAction()),
  getProfile: () => dispatch(getProfileAction()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(App);



// WEBPACK FOOTER //
// ./src/modules/common/containers/App.js